import styled, { css } from 'styled-components';
import { toRem } from '../../styles';

const IMAGE_SIZE_PX = 100;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Wrapper = styled.div<{ $isLinked?: boolean }>`
  display: flex;
  align-items: center;
  inline-size: 100%;
  max-inline-size: 100%;
  block-size: ${toRem(IMAGE_SIZE_PX)};
  max-block-size: ${toRem(IMAGE_SIZE_PX)};
  overflow: hidden;
  border-radius: var(--t-cards-border-radius, ${toRem(14)});
  background-color: var(--t-brand-bg-color, white);
  transition: box-shadow 0.2s ease-in-out;

  /* shadow-s: base shadow for all cards */
  box-shadow: 0 0.25rem 1.25rem rgba(0, 0, 0, 0.07);

  /* shadow-m: elevated shadow on hover (interactive cards only) */
  ${({ $isLinked }) =>
    $isLinked &&
    css`
      &:hover,
      &:focus-within {
        box-shadow: 0 0.4375rem 1.25rem rgba(0, 0, 0, 0.25);
      }
    `}
`;

export const LinkWrapper = styled.a`
  display: flex;
  align-items: center;
  inline-size: 100%;
  block-size: 100%;
  text-decoration: none;
  color: inherit;

  &:hover,
  &:focus,
  &:active,
  &:visited {
    text-decoration: none;
    color: inherit;
  }

  &:focus-visible {
    outline: none;
    box-shadow: inset 0 0 0 2px var(--t-brand-fg-color);
    border-radius: var(--t-cards-border-radius, ${toRem(14)});
  }
`;

export const ImageWrapper = styled.div`
  flex-shrink: 0;
  inline-size: ${toRem(IMAGE_SIZE_PX)};
  block-size: ${toRem(IMAGE_SIZE_PX)};
  overflow: hidden;

  picture {
    display: block;
    inline-size: 100%;
    block-size: 100%;
  }

  img {
    display: block;
    inline-size: 100%;
    block-size: 100%;
    object-fit: cover;
    aspect-ratio: unset;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1 1 0;
  align-items: center;
  gap: var(--general-spacer-03, 1rem);
  block-size: 100%;
  min-inline-size: 0;
  overflow: hidden;
  padding-inline: var(--general-spacer-03, 1rem);
`;

export const TextWrapper = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-inline-size: 0;
  overflow: hidden;
`;

export const HeaderSlot = styled.div<{ $hasBody?: boolean }>`
  inline-size: 100%;
  padding-block-end: var(--general-spacer-01, ${toRem(4)});

  > * {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${({ $hasBody }) => ($hasBody ? 2 : 3)};
    overflow: hidden;
  }
`;

export const BodySlot = styled.div`
  inline-size: 100%;
  padding-block-end: var(--general-spacer-01, ${toRem(4)});

  > * {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
